module.exports = " <div class=weui_tabbar> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/tabbar/tabbar.vue
// module id = 255
// module chunks = 2